import { createAPI } from '@common'

// MediaCloudNewsPlanTopics
export default {
  // 选题策划设置人员列表中置灰已设置的人员
  queryE5ListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60mjtuebub', 'post', config, {}),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60bdujpot0efubjmbdujpot', 'get', config),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  // 获取根节点
  getRoot: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  // 获取根节点new
  getRootNew: (config) =>
    // createAPI('customEncryptApiName33/0nfejby.ofxtqmbo0f60gpmefst0sppu?docLib=133', 'get', config),
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60gpmefst0sppu', 'get', config),
  // 获取子节点
  getSubs: (config) => createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60gpmefst', 'get', config),
  // 新建类型
  getAddType: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0hfuDbuUzqf', 'get', config),
  // 获取负责人信息（就是获取人员信息接口
  getAddUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0vtfst', 'get', config),
  // 获取负责人信息(带分页)
  getUsersWithPage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0vtfstXjuiQbhf', 'get', config),
  // 获取负责人中是否包含当前账号
  getUsersWithPageIsResponsible: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0jtSftqpotjcmf', 'get', config),
  // 写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0dsfbujpo0jojujbmj{bujpo',
      'get',
      config
    ),
  // 写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 获取稿件详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0efubjm', 'get', config),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0efubjm', 'get', config),
  // 获取列表查询项详情
  getOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0pqujpot', 'get', config),
  // 获取执行人列表
  getAssignUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0bttjho0hfuVtfstXjuiQbhf',
      'get',
      config
    ),
  // 派工
  postAssign: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0bttjho', 'post', config),
  // 认领
  postClaim: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0dmbjn', 'post', config),
  // 获取选题基本信息
  getBaseInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0hfuCbtfJogp', 'get', config),
  // 获取稿签位置
  getLocations: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0mpdbujpot', 'get', config, {
      neverLoading: true
    }),
  // 选题策划-查询用户关联的选题
  getUserPlans: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0hfuVtfsQmbot', 'get', config, {
      neverLoading: false
    }),
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0usbotgfs', 'post', config),
  // 下发
  postArticleSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0tfoe', 'post', config),
  // 解除下发
  postArticleCancelSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0dbodfmTfoe', 'post', config),

  // 驳回
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0sfkfdu', 'post', config),
  // 通过
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0qbtt', 'post', config),
  // 移动
  postArticlesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0npwf', 'post', config),
  // 上会
  postArticlesMeet: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0nffu', 'post', config),
  // 指导意见
  postArticlesOpinion: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0pqjojpo', 'post', config),
  // 退回
  postArticlesReturn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0xjuiesbx', 'post', config),
  // 设置上会时间
  postSetMeetTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0tfuNffuUjnf', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUser: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 获取不同用户修改痕迹(新)
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0wfstjpo0usbdf0vtfst0bmufsobuf0ofx',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 删除
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0efmfuf', 'post', config),
  // 获取导出字段列表
  getExportFields: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0fyqpsu0gjfmet', 'get', config),
  // 导出
  postArticlesExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0fyqpsu', 'post', config, {
      timeout: 60000
    }),
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0bttjho0tubuvt', 'get', config),
  //我的代办 获取选题策划的稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0efubjm', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getFolderPermissions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0gpmefs0qfsnjttjpot', 'get', config),

  // 反馈
  postNewsplanFeedBack: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0qspd0gffeCbdl', 'post', config),
  // 批量新建
  postNewsplanBatchcreate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0cbudidsfbuf', 'post', config),
  // 选题策划-提取关键词
  postContentKeyword: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0lfzxpse', 'post', config),
  // 选题策划-获取右键操作权限
  getActions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60bdujpot', 'get', config, vconfig),
  // 选题策划-树节点添加子文件夹
  postNewsplanAddFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0beeGpmefs', 'post', config),
  // 选题策划-树节点删除文件夹
  postNewsplanDeleteFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0ofxtqmbo0efmfufGpmefs', 'post', config),
}
